import { configureStore } from "@reduxjs/toolkit";

import { cryptoNewsApi } from "../services/CryptonewsAPI";

import { cryptoApi } from "../services/cryptoAPI";
export default configureStore({
  reducer: {
    [cryptoApi.reducerPath]: cryptoApi.reducer,
    [cryptoNewsApi.reducerPath]: cryptoNewsApi.reducer,
  },
});
